import { Card } from "@/components/ui/card";
import { Clock } from "lucide-react";
import { t } from "@/i18n";

export const EmptyState = ({ lang = "da" }) => (
  <div className="space-y-6 animate-fade-in-up" data-testid="empty-state">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {[1, 2, 3, 4].map((i) => (
        <Card key={i} className="bg-card border-border shadow-none p-6">
          <div className="h-3 w-24 bg-secondary rounded mb-4" />
          <div className="h-8 w-32 bg-secondary rounded mb-2" />
          <div className="h-3 w-20 bg-secondary rounded" />
        </Card>
      ))}
    </div>

    <Card className="bg-card border-border shadow-none p-6">
      <div className="h-4 w-40 bg-secondary rounded mb-6" />
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex items-center gap-4">
            <div className="w-8 h-8 rounded-full bg-secondary" />
            <div className="h-4 bg-secondary rounded flex-1" />
            <div className="h-4 w-16 bg-secondary rounded" />
          </div>
        ))}
      </div>
    </Card>

    <div className="flex flex-col items-center justify-center py-12 gap-4">
      <div className="w-14 h-14 rounded-full bg-secondary flex items-center justify-center">
        <Clock className="w-7 h-7 text-muted-foreground" />
      </div>
      <div className="text-center">
        <p className="text-foreground font-semibold text-base">{t(lang, "noDataTitle")}</p>
        <p className="text-muted-foreground text-sm mt-1">{t(lang, "noDataSubtitle")}</p>
      </div>
    </div>
  </div>
);
